import { h, Component } from 'preact'
import styled from 'styled-components'
import PoliticianVotepoint from './politician-votepoint'

const LawCard = styled.div`
  > h4 {
    margin: 24px 0 0px 15px;
  }
`

export default class PoliticianSection extends Component {
  render() {
    const { votepoint, percent, points, votes, options } = this.props
    return (
      <LawCard>
        <h4>{`${votepoint.title}: ${percent}%`}</h4>
        {points.map((point, j) => (
          <PoliticianVotepoint
            title={votepoint.titles[j]}
            vote={votes[j]}
            options={options}
            text={point[0]}
          />
        ))}
      </LawCard>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/politician/politician-section.js